// src/lib/api/engagementApi.ts
import { getApiClient } from './client';
import type { Employee, CandidateEngagement } from '@/lib/models/engagement';

const listOrganisationEmployees = async (organisationId: string): Promise<Employee[]> => {
    const data = await getApiClient().get<Employee[]>(`/api/organisations/${organisationId}/engagements`);
    return Array.isArray(data) ? data : [];
};

const listUnitEmployees = async (unitId: string): Promise<Employee[]> => {
    const data = await getApiClient().get<Employee[]>(`/api/units/${unitId}/engagements`);
    return Array.isArray(data) ? data : [];
};

// Offboard an employee — end their engagement (B6).
const endEngagement = async (engagementId: string): Promise<void> => {
    await getApiClient().patch(`/api/engagements/${engagementId}/end`, {});
};

// The candidate's own engagement history (active + ended), for the home card.
const listMyEngagements = async (): Promise<CandidateEngagement[]> => {
    const data = await getApiClient().get<{ engagements: CandidateEngagement[] }>('/api/my/engagements');
    return Array.isArray(data?.engagements) ? data.engagements : [];
};

export const engagementApi = {
    listOrganisationEmployees,
    listUnitEmployees,
    endEngagement,
    listMyEngagements,
};
